<div class="wrapper wrapper-full-page ovsuite-login-background">
  <div class="">
    <div class="">
      <div class="d-flex flex-row 100-vh flex-gr">
        <div class="flex-even d-block">
          <div class="">
            <div class="ml-5 mr-5">
              <div class="form">
                <div class="card-login">
                  <div *ngIf="loading" class="loader-left loader"></div>
                  <div *ngIf="!loading">
                    <div>
                      <img
                        class="logo-header"
                        src="../../../assets/img/ovsuite-logo.png"
                        height="97"
                        width="265"
                        alt="Link Logo"
                      />
                    </div>
                    <h1 class="header-top" *ngIf="!forgotPassword">
                      Hello. Welcome to OV Suite. Please login.
                    </h1>
                    <h1 class="header-top" *ngIf="forgotPassword">
                      Hello. Welcome to OV Suite. Forgot Password?
                    </h1>
                    <h6>
                      <small *ngIf="forgotPassword">
                        Enter your email and verification code.
                      </small>
                    </h6>
                  </div>
                  <div class="login-form" *ngIf="!federated && !loading">
                    <div
                      class="input-group"
                      [ngClass]="{ 'input-group-focus': focus === true }"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i
                            aria-hidden="true"
                            class="nc-icon nc-single-02"
                          ></i>
                        </span>
                      </div>
                      <input
                        name="username"
                        required
                        [(ngModel)]="user.email"
                        type="text"
                        class="form-control"
                        placeholder="Email Address"
                        (focus)="focus = true"
                        (blur)="focus = false"
                      />
                    </div>
                    <div
                      class="input-group"
                      [ngClass]="{ 'input-group-focus': focus1 === true }"
                      *ngIf="!forgotPassword"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i aria-hidden="true" class="fa fa-key"></i>
                        </span>
                      </div>
                      <input
                        id="password-input"
                        name="password"
                        required
                        [(ngModel)]="password"
                        (keyup.enter)="signIn()"
                        [type]="passwordVisible ? 'value' : 'password'"
                        placeholder="Password"
                        class="form-control"
                        (focus)="focus1 = true"
                        (blur)="focus1 = false"
                      />

                      <i
                        id="input-group-text-pass-hidden"
                        (click)="togglePasswordVisibility()"
                        class="fa fa-eye fa-2x"
                        aria-hidden="true"
                      ></i>
                    </div>

                    <div
                      class="input-group"
                      [ngClass]="{ 'input-group-focus': focus1 === true }"
                      *ngIf="
                        !forgotPassword && authState != 'NEW_PASSWORD_REQUIRED'
                      "
                    >
                      <div class="form-check">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" />
                          <span class="form-check-sign"></span> Remember me
                        </label>
                      </div>
                    </div>

                    <div
                      class="input-group"
                      [ngClass]="{ 'input-group-focus': focus === true }"
                      *ngIf="forgotPassword"
                    >
                      <div *ngIf="!!user.email" class="input-group-prepend">
                        <span class="input-group-text">
                          <i
                            aria-hidden="true"
                            class="nc-icon nc-single-02"
                          ></i>
                        </span>
                      </div>
                      <input *ngIf="!!user.email"
                        name="verificationCode"
                        required
                        [(ngModel)]="verificationCode"
                        type="text"
                        class="form-control"
                        placeholder="Verification Code"
                      />
                    </div>
                    <div
                      class="input-group"
                      [ngClass]="{ 'input-group-focus': focus1 === true }"
                      *ngIf="
                        authState === 'NEW_PASSWORD_REQUIRED' ||
                        (forgotPassword && !!verificationCode)
                      "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i aria-hidden="true" class="fa fa-key"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        id="newPassword"
                        class="form-control"
                        [(ngModel)]="newPassword"
                        placeholder="Please create a new Password"
                        required
                        (ngModelChange)="confirmPasswordsMatch()"
                      />
                    </div>
                    <div
                      class="input-group"
                      [ngClass]="{ 'input-group-focus': focus1 === true }"
                      *ngIf="
                        authState === 'NEW_PASSWORD_REQUIRED' ||
                        (forgotPassword && !!verificationCode)
                      "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i aria-hidden="true" class="fa fa-key"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        id="confirmPassword"
                        class="form-control"
                        [(ngModel)]="confirmPassword"
                        placeholder="Please confirm your new Password"
                        required
                        (ngModelChange)="confirmPasswordsMatch()"
                      />
                    </div>
                    <span
                      *ngIf="
                        authState === 'NEW_PASSWORD_REQUIRED' ||
                        (forgotPassword && !!verificationCode)
                      "
                    >
                      <div class="pull-right">
                        <small
                          *ngIf="!passwordsMatch && password && confirmPassword"
                          class="mt-2 text-danger"
                          >Passwords do not match.</small
                        >
                      </div>
                    </span>
                    <span
                      class="bmd-form-group"
                      *ngIf="requiredResponse.includes('name')"
                    >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons" aria-hidden="true">face</i>
                          </span>
                        </div>
                        <input
                          type="text"
                          id="name"
                          class="form-control text-white"
                          placeholder="Please add your first name"
                          [(ngModel)]="user.name"
                          (focusout)="user.name = user.name.trim()"
                          required
                        />
                      </div>
                    </span>
                    <span
                      class="bmd-form-group"
                      *ngIf="requiredResponse.includes('family_name')"
                    >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons" aria-hidden="true">accessibility_new</i>
                          </span>
                        </div>
                        <input
                          type="text"
                          id="familyName"
                          class="form-control text-white"
                          placeholder="Please add your family name"
                          [(ngModel)]="user.familyName"
                          (focusout)="user.familyName = user.familyName.trim()"
                          required
                        />
                      </div>
                    </span>
                    <span
                      class="bmd-form-group"
                      *ngIf="requiredResponse.includes('phone_number')"
                    >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons" aria-hidden="true">mobile_friendly</i>
                          </span>
                        </div>
                        <input
                          type="text"
                          id="phoneNumber"
                          class="form-control text-white"
                          placeholder="Please add your phone number"
                          [(ngModel)]="user.phoneNumber"
                          required
                        />
                      </div>
                    </span>
                    <br />
                  </div>
                  <div class="" *ngIf="!federated && !loading">
                    <button
                      (click)="signIn()"
                      type="button"
                      class="btn btn-primary btn-round btn-lg btn-block mb-3"
                      *ngIf="!forgotPassword || newPassword"
                      [disabled]="
                        !user.email || (forgotPassword && !passwordsMatch)
                      "
                    >
                      Get Started
                    </button>
                    <button
                      (click)="forgotPasswordClick()"
                      type="button"
                      class="btn btn-primary btn-round btn-lg btn-block mb-3"
                      *ngIf="forgotPassword && !newPassword"
                      [disabled]="!user.email || verificationCode"
                    >
                      Get Verification Code
                    </button>
                  </div>
                  <div
                    class="form-footer-container d-flex justify-content-between"
                    *ngIf="!federated && !loading"
                  >
                    <button
                      class="btn btn-link"
                      (click)="forgotPassword = true"
                    >
                      Forgot password?
                    </button>
                  </div>
                  <div *ngIf="federated">
                    <button
                      (click)="federatedSignIn()"
                      type="button"
                      class="btn btn-primary btn-round btn-lg btn-block mb-3"
                    >
                      {{ federatedText }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-even d-none d-xl-block"></div>

        <div class="flex-even d-none d-md-block"></div>
      </div>
    </div>
  </div>
</div>
